import "./cardCarrouselCategory.sass";

/**
 * Renderiza una tarjeta del carrusel de categoria con el logo.
 * Generalmente se utiliza para representar visualmente deportes, secciones, marcas, etc.
*/
export default function CardCarrouselCategory({ item }) {
  const { id_opta, nombre, short_name, official_name, code, order, slug_wp, image, url} = item;

  return (
    <div className="carrousel-category__card">
      <a href={url ? url : ""} target="_parent" rel="noreferrer">
        <img src={image} alt={nombre} loading="lazy" />
      </a>
    </div>
  )
}